import { useEffect, useState } from 'react'

/**
 * Subscribe to a CSS media query. Returns whether it currently matches.
 * SSR-safe: defaults to ``false`` when ``window`` is undefined.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState<boolean>(() => {
    if (typeof window === 'undefined') return false
    return window.matchMedia(query).matches
  })

  useEffect(() => {
    if (typeof window === 'undefined') return
    const mql = window.matchMedia(query)
    const onChange = (e: MediaQueryListEvent) => {
      setMatches(e.matches)
    }
    setMatches(mql.matches)
    mql.addEventListener('change', onChange)
    return () => {
      mql.removeEventListener('change', onChange)
    }
  }, [query])

  return matches
}

/** Mobile = below the desktop breakpoint (1024px). */
export function useIsMobile(): boolean {
  return useMediaQuery('(max-width: 1023px)')
}
